import React from 'react'
import Phonecall from "../../Images/phoencalimage.png"
import Address from "../../Images/adressimage.png"
import Emailimage from "../../Images/emailimage.png"
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'

function TermsCondition() {
  return (
   <>
   <HomeNavbar />
      <div
          id="faqs-page"
          className="bg-white w-full py-20  text-center font-oswald mt-10"
        >
          <div className=" flex items-center justify-center">
            <p
              style={{ backgroundColor: "#EFEEFE" }}
              className="  rounded-full py-2 px-6 font-bold text-bgBlue"
            >
             T&C
            </p>
          </div>
          <br />
          <h2 className="text-3xl font-bold text-gray-900  animate-fade-in">
            Term's &<span className="text-purple">  Condition's </span>{" "}
          </h2>
         
         

         <div className='lg:w-3/4 m-auto shadow-xl'>
         <div className=" text-bgBlue p-8">
      <div className="text-start">
        <h1 className="text-4xl font-bold mb-4">Terms and Conditions</h1>
        <p className="mb-4">Effective Date:30 Nov 2025</p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Introduction</h2>
          <p className="mb-2">
            <h1 className='font-bold'>This Website is Owned & Operated by AKRYPT IT SOLUTIONS PRIVATE LIMITED</h1>
            These Terms and Conditions govern your use of the Learn2Earn24x7 app and
            website. By accessing or using our services, you accept and agree to
            be bound by these terms. If you do not agree with these terms,
            please do not use our services.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Acceptance of Terms</h2>
          <p className="mb-2">
            By accessing Learn2Earn24x7, you agree to these Terms and Conditions and
            any modifications that may be made from time to time. Continued use
            of the service after any such changes shall constitute your consent
            to such changes.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Use of Service</h2>
          <p className="mb-2">
            Learn2Earn24x7 is designed to help users prepare for Indian civil
            services exams (such as UPSC, State PSCs) by solving questions.
            Users can earn money by participating in these activities. You agree
            to use the service for lawful purposes only and in a way that does
            not infringe on the rights of others.
          </p>
          <p className="mb-2">
            The content provided on Learn2Earn24x7, including study materials and
            quizzes, is intended for personal use only. Unauthorized commercial
            use or redistribution of content is strictly prohibited.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Account Registration</h2>
          <p className="mb-2">
            To access certain features of Learn2Earn24x7, you may need to register an
            account. You must provide accurate and complete information during
            registration and keep your account information updated. Each
            individual is allowed to create only one account. Duplicate accounts
            may be removed at our discretion.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">User Responsibilities</h2>
          <p className="mb-2">
            You are responsible for safeguarding your account login credentials
            and for all activities that occur under your account. You agree not
            to engage in any activity that could harm or disrupt the service.
            You must comply with all applicable laws, including Indian IT laws,
            while using the service.
          </p>
          <p className="mb-2">
            Any fraudulent activity, such as using bots to solve questions, is
            strictly prohibited. Violations may result in the suspension or
            termination of your account.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Intellectual Property</h2>
          <p className="mb-2">
            All content provided on Learn2Earn24x7, including text, images, logos,
            and software, is owned by Learn2Earn24x7 and is protected by Indian
            intellectual property laws. You may not use any content from
            Learn2Earn24x7 without our express written permission.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Earnings and Payouts</h2>
          <p className="mb-2">
            Users can earn money by correctly answering questions and
            participating in challenges. The earnings are credited to your
            account and can be withdrawn to your bank account or digital wallet
            once a minimum threshold is reached. Payouts are processed as per
            the applicable Indian tax laws, and you may be required to provide
            necessary tax-related information.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Limitation of Liability</h2>
          <p className="mb-2">
            Learn2Earn24x7 is provided "as is" without warranties of any kind, either
            express or implied. We do not guarantee the accuracy or completeness
            of the content on our platform. Learn2Earn24x7 will not be liable for any
            damages arising from your use of the service.
          </p>
          <p className="mb-2">
            In no event shall Learn2Earn24x7 be liable for any indirect, incidental,
            special, or consequential damages arising out of or in connection
            with the use of our services, including but not limited to loss of
            earnings, data, or profits.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Termination</h2>
          <p className="mb-2">
            We reserve the right to terminate or suspend your account and access
            to Learn2Earn24x7 at our sole discretion, without prior notice, for
            conduct that we believe violates these terms or is harmful to other
            users or the service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Governing Law</h2>
          <p className="mb-2">
            These Terms and Conditions shall be governed by and construed in
            accordance with the laws of India. Any disputes arising out of or in
            connection with these terms shall be subject to the exclusive
            jurisdiction of the courts of Burhanpur M.P, India.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Changes to Terms</h2>
          <p className="mb-2">
            Learn2Earn24x7 reserves the right to modify these Terms and Conditions at
            any time. We will notify users of significant changes by email or
            through our app. Your continued use of the service after such
            changes signifies your acceptance of the new terms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Contact Information</h2>
          <p className="mb-2">
            If you have any questions about these Terms and Conditions, please
            contact us at{" "}
            <a
              href="mailto:support@learn2earn24x7.com"
              className="text-blue-500 underline"
            >
              support@learn2earn24x7.com
            </a>
            .
          </p>
        </section>
      </div>
    </div>
         </div>
        </div>
        <Footer/>
   </>
  )
}

export default TermsCondition
